const $ = window.jQuery;

$(function () {
    let elements = '';

    // Function to adjust the height of elements with class 'red-border'
    function adjustHeights() {
        if ($(window).width() > 1024) {
            let maxHeight = 0;

            // Loop through all elements to find the tallest one
            elements.each(function () {
                const elementHeight = $(this).outerHeight();
                if (elementHeight > maxHeight) {
                maxHeight = elementHeight;
                }
            });

            // Set all elements to the tallest height
            elements.each(function() {
                $(this).height(maxHeight);
            });

        } else {
            $('.aka-block-info-image-cards h2').each(function() {
                $(this).css('height', '');
            });
        }
    }

    if ($('.aka-block-info-image-cards').length) {
        elements = $('.aka-block-info-image-cards h2');

        adjustHeights();

        $(window).on('resize', function () {
            elements.css('height', '');
            adjustHeights();
        });

    }


    
});
